/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Toast_Status_SetInputs */

const en_toast_status_set = /** @type {(inputs: Toast_Status_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status set to ${i?.status}`)
};

const de_toast_status_set = /** @type {(inputs: Toast_Status_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status auf ${i?.status} gesetzt`)
};

/**
* | output |
* | --- |
* | "Status set to {status}" |
*
* @param {Toast_Status_SetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_status_set = /** @type {((inputs: Toast_Status_SetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Status_SetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_status_set(inputs)
	return en_toast_status_set(inputs)
});